import {useSuspenseQuery} from '@tanstack/react-query';
import {injectRecentSort, prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {documentListSchema} from '../utils/schemas/document';

import {documentKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getDocuments = async (params: QueryParams = {}) => {
  const res = await api.get(`documents`, {
    searchParams: prepareSearchParams(injectRecentSort(params)),
  });
  const data = await res.json();
  const pagination = extractPagination(res);
  return [documentListSchema.parse(data), pagination] as const;
};

export const useDocuments = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: documentKeys.list(params),
    queryFn: () => getDocuments(params),
  });
};
export const useDocumentsLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getDocuments;
type QueryParams = Parameters<typeof documentKeys.list>[0];
